import React from 'react';
import { Input, Label } from 'reactstrap';

const SfCustomCheckBox = ({
    index,
    filter,
    custom_css,
    handle_checkbox_value
}) => {

    return (
        <div className={custom_css}>
            <Input
                id={`custom-prospect-filter-${filter?.name}`}
                type="checkbox"
                name={filter?.name}
                value={!!filter?.is_active}
                defaultChecked={!!filter?.is_active}
                onChange={(e) => handle_checkbox_value(index, e.target.checked)}
            />
            <Label className='ms-1 fw-normal' htmlFor={`custom-prospect-filter-${filter?.name}`} check>
                {filter?.label}
            </Label>
        </div>
    )
}

export default SfCustomCheckBox;
